import { Box, Container, Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FaqSummary from '../../components/Faq/FaqSummary';
import { StyledLink } from '../../components/Utils/UIUtils';

export default function Section9() {
  const { t } = useTranslation();

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column' },
        justifyContent: 'center',
        alignItems: 'center',
        py: { xs: 8, md: 10 },
      }}
      maxWidth="lg"
    >
      <Stack gap={4} sx={{ width: '100%' }}>
        <Stack component={'header'}>
          <Typography
            variant="h2"
            sx={{ fontSize: '40px', fontWeight: '700', textAlign: 'center' }}
          >
            {t('HOME_PAGE.SECTION9.TITLE')}
          </Typography>
        </Stack>

        <Box sx={{ width: { xs: '100%', md: '70%' }, mx: 'auto' }}>
          <FaqSummary />
        </Box>
        <StyledLink
          component={Link}
          href="/faq"
          variant="body1"
          sx={{
            fontSize: '16px',
            fontWeight: '500',
            textAlign: 'center',
            color: 'primary.main',
          }}
        >
          {t('HOME_PAGE.SECTION9.SEE_MORE')}
        </StyledLink>
      </Stack>
    </Container>
  );
}
